import { Clickable, Col, LockGradient, Post, PostBox, Row, Text } from 'components';
import { theme } from 'lib';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Image = styled.div`
  position: relative;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  background: url(${(props) => props.src});
  background-repeat: no-repeat;
  z-index: 1;
  background-size: cover;
  background-position: center;
`;

const BackgroundStrip = styled.div`
  height: 175px;
  width: 100vw;
  background-color: ${theme.FOG};
  margin-top: -159px;
  z-index: 0;
`;

// Container for PostsGrid
const PostsGrid = ({
  data,
  title,
  contentLocked,
  handleUnlock,
  haveBackgroundStrip,
  marg,
  showFour,
  onSeeAll,
  hasBack,
  handleSignup,
  otherUser,
  setOtherUser = null,
  fetchMore = () => null
}) => {
  const [selectedPost, setSelectedPost] = useState(-1),
    { t } = useTranslation(),
    isMobile = useSelector((state) => state.appState.isMobile),
    user = useSelector((state) => state.user),
    dispatch = useDispatch(),
    navigate = useNavigate(),
    observer = useRef();

  // Handle app state when user is not logged in
  function handleGetApp() {
    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        showGetApp: true
      }
    });
  }

  // Handle next post navigation
  function handleNext() {
    if (data.length - selectedPost < 5) fetchMore();
    setSelectedPost(selectedPost + 1);
  }

  // Handle post selection
  async function handleClick(index) {
    setSelectedPost(index); // show preview modal

    const postDetails = data[index];

    if (!postDetails && !postDetails._id) {
      return;
    }

    // handleUpdateProfileViewsCount(); // update local state of owner views
  }

  function handleSeeAllClick(index) {
    if (!user) return handleSignup();

    setSelectedPost(0); // set default index to 0
    const postDetails = data?.[0];

    if (!postDetails && !postDetails._id) {
      return;
    }

    // handleUpdateProfileViewsCount(); // update local state of owner views
  }

  const handleUpdateProfileViewsCount = () => {
    if (setOtherUser && typeof setOtherUser === 'function') {
      setOtherUser((prev) => ({
        ...prev,
        profileViewsCount: prev.profileViewsCount + 1
      }));
    }
  };

  if (!data?.length) return null;

  // Mobile Layout
  if (isMobile) {
    return (
      <Col wid="100%" marg={marg} pos="relative">
        <Row pad="0 16px" between wid="calc(100% - 32px)" center>
          <Text h2>{title}</Text>

          <Clickable onClick={contentLocked ? handleUnlock : handleSeeAllClick}>
            <Text b2 bold>
              {contentLocked ? t('common.unlock') : t('common.seeAll')}
            </Text>
          </Clickable>
        </Row>

        {data.length && (
          <React.Fragment>
            <Row
              start
              style={{ overflowX: 'auto' }}
              wid="100vw"
              marg="8px 0 0"
              zIndex="1"
              hideScrollBar
              ref={observer}
            >
              <Row pad="0 16px" gap="16px">
                {data?.slice(0, contentLocked ? 4 : data.length)?.map((x, i) => (
                  <PostBox key={x._id} index={i} item={x} onClick={handleClick} />
                ))}
              </Row>
            </Row>

            {haveBackgroundStrip && <BackgroundStrip />}
          </React.Fragment>
        )}

        <LockGradient visible={contentLocked} observer={observer} />

        {selectedPost !== -1 && (
          <Post
            showBack={selectedPost !== 0}
            handleBack={() => setSelectedPost(selectedPost - 1)}
            showNext={selectedPost !== data.length - 1}
            handleNext={handleNext}
            item={data[selectedPost]}
            handleClose={() => setSelectedPost(-1)}
            isFixed={true}
            onHandleUpdateProfileViewsCount={handleUpdateProfileViewsCount}
          />
        )}
      </Col>
    );
  }

  // Desktop Layout
  return (
    <Col>
      <Col marg={marg} pos="relative">
        <Row between center wid="100%" marg="0 0 16px">
          <Row centerAll noFlex>
            <Text h2>{title}</Text>
          </Row>

          {(showFour || contentLocked) && data.length >= 3 && (
            <Clickable onClick={contentLocked ? handleUnlock : onSeeAll}>
              <Text b2 bold>
                {contentLocked ? t('common.unlock') : t('common.seeAll')}
              </Text>
            </Clickable>
          )}
        </Row>

        <Row wrapFlex gap="20px 24px" start ref={observer}>
          {data.slice(0, showFour || contentLocked ? 4 : data.length).map((x, i) => (
            <PostBox key={i} item={x} index={i} onClick={handleClick} />
          ))}
        </Row>
        <LockGradient visible={contentLocked} observer={observer} />
      </Col>
      {selectedPost !== -1 && (
        <Post
          showBack={selectedPost !== 0}
          handleBack={() => setSelectedPost(selectedPost - 1)}
          showNext={selectedPost !== data.length - 1}
          handleNext={handleNext}
          item={data[selectedPost]}
          handleClose={() => setSelectedPost(-1)}
          isFixed={true}
          onHandleUpdateProfileViewsCount={handleUpdateProfileViewsCount}
        />
      )}
    </Col>
  );
};

export default PostsGrid;
